if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        console.log('[product-form] script loaded');

        this.form = this.querySelector('form');
        if (!this.form) {
          console.warn('[product-form] No form found inside <product-form>');
          return;
        }

        // Re-enable variant ID input (Shopify disables it for JS forms)
        if (this.variantIdInput) {
          this.variantIdInput.disabled = false;
        }

        // === PERSONALIZATION ADD-ONS (MATCHING YOUR LIQUID MARKUP) ===
        // Team number
        this.addonTeamNumberCheckbox = this.form.querySelector(
          'input[name="properties[Add team number]"]'
        );
        this.addonTeamNumberInput = this.form.querySelector(
          'input[name="properties[Team number]"]'
        );
        this.addonTeamNumberVariantIdInput = this.form.querySelector(
          'input[name="properties[team_number_addon_variant_id]"]'
        );
        this.addonTeamNumberVariantId = this.addonTeamNumberVariantIdInput
          ? this.addonTeamNumberVariantIdInput.value
          : undefined;

        // Team logo
        this.addonTeamLogoCheckbox = this.form.querySelector(
          'input[name="properties[Add team logo]"]'
        );
        this.addonTeamLogoFileInput = this.form.querySelector(
          'input[name="properties[Team logo file]"]'
        );
        this.addonTeamLogoVariantIdInput = this.form.querySelector(
          'input[name="properties[team_logo_addon_variant_id]"]'
        );
        this.addonTeamLogoVariantId = this.addonTeamLogoVariantIdInput
          ? this.addonTeamLogoVariantIdInput.value
          : undefined;

        console.log('[product-form] addon DOM refs', {
          addonTeamNumberCheckbox: !!this.addonTeamNumberCheckbox,
          addonTeamNumberInput: !!this.addonTeamNumberInput,
          addonTeamNumberVariantId: this.addonTeamNumberVariantId,
          addonTeamLogoCheckbox: !!this.addonTeamLogoCheckbox,
          addonTeamLogoFileInput: !!this.addonTeamLogoFileInput,
          addonTeamLogoVariantId: this.addonTeamLogoVariantId,
        });

        // Cart + submit button
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton?.querySelector('span');

        if (document.querySelector('cart-drawer') && this.submitButton) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (!this.submitButton) return;

        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        const spinner = this.querySelector('.loading__spinner');
        if (spinner) spinner.classList.remove('hidden');

        // === VALIDATE ADD-ONS BEFORE ANY NETWORK CALLS ===
        const validationError = this.validateAddons();
        if (validationError) {
          console.warn('[product-form] validation error:', validationError);
          this.handleErrorMessage(validationError);
          this.submitButton.classList.remove('loading');
          this.submitButton.removeAttribute('aria-disabled');
          if (spinner) spinner.classList.add('hidden');
          return;
        }

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        config.body = formData;

        console.log(
          '[product-form] submitting base product, variant id:',
          formData.get('id')
        );

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then(async (response) => {
            console.log('[product-form] base product response:', response);

            if (response.status) {
              // Error adding base product
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText?.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              // No AJAX cart, redirect to cart
              window.location = window.routes.cart_url;
              return;
            }

            // === ADD PERSONALIZATION ADD-ONS AFTER BASE PRODUCT ===
            const addonsResponse = await this.addAddonsIfNeeded();
            const finalResponse = addonsResponse || response;

            const startMarker = CartPerformance.createStartingMarker(
              'add:wait-for-subscribers'
            );
            if (!this.error) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: finalResponse,
              }).then(() => {
                CartPerformance.measureFromMarker(
                  'add:wait-for-subscribers',
                  startMarker
                );
              });
            }

            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');

            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure(
                      'add:paint-updated-sections',
                      () => {
                        this.cart.renderContents(finalResponse);
                      }
                    );
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure(
                'add:paint-updated-sections',
                () => {
                  this.cart.renderContents(finalResponse);
                }
              );
            }
          })
          .catch((e) => {
            console.error('[product-form] base product fetch error:', e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) {
              this.cart.classList.remove('is-empty');
            }
            if (!this.error) {
              this.submitButton.removeAttribute('aria-disabled');
            }
            const spinnerFinal = this.querySelector('.loading__spinner');
            if (spinnerFinal) spinnerFinal.classList.add('hidden');

            CartPerformance.measureFromEvent('add:user-action', evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;

        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            '.product-form__error-message'
          );

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage && this.errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (!this.submitButton) return;

        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text && this.submitButtonText)
            this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          if (this.submitButtonText) {
            this.submitButtonText.textContent = window.variantStrings.addToCart;
          }
        }
      }

      // === VALIDATION: prevent submit if checkbox is checked but input/file is missing ===
      validateAddons() {
        // Team number
        if (this.addonTeamNumberCheckbox && this.addonTeamNumberCheckbox.checked) {
          const value = (this.addonTeamNumberInput?.value || '').trim();
          console.log('[product-form] validating team number:', value);
          if (!value) {
            return 'Please enter a team number to add team number personalization.';
          }
        }

        // Team logo
        if (this.addonTeamLogoCheckbox && this.addonTeamLogoCheckbox.checked) {
          const fileInput = this.addonTeamLogoFileInput;
          const hasFile =
            fileInput && fileInput.files && fileInput.files[0]
              ? true
              : false;
          console.log('[product-form] validating team logo, hasFile:', hasFile);
          if (!hasFile) {
            return 'Please upload a logo file to add team logo personalization.';
          }
        }

        return null;
      }

      // === ADD-ON CART REQUESTS ===
      async addAddonsIfNeeded() {
        const requests = [];

        // Team number add-on
        if (
          this.addonTeamNumberCheckbox &&
          this.addonTeamNumberCheckbox.checked &&
          this.addonTeamNumberVariantId
        ) {
          const fd = new FormData();
          fd.append('id', this.addonTeamNumberVariantId);
          fd.append('quantity', 1);

          const value = (this.addonTeamNumberInput?.value || '').trim();
          if (value) {
            fd.append('properties[Team number]', value);
          }

          if (this.cart) {
            fd.append(
              'sections',
              this.cart.getSectionsToRender().map((section) => section.id)
            );
            fd.append('sections_url', window.location.pathname);
            this.cart.setActiveElement(document.activeElement);
          }

          const configNumber = fetchConfig('javascript');
          configNumber.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete configNumber.headers['Content-Type'];
          configNumber.body = fd;

          console.log(
            '[product-form] adding team number add-on, variant id:',
            this.addonTeamNumberVariantId,
            'value:',
            value
          );

          requests.push(
            fetch(`${routes.cart_add_url}`, configNumber)
              .then((res) => res.json())
              .then((json) => {
                console.log(
                  '[product-form] team number add-on response:',
                  json
                );
                return json;
              })
          );
        }

        // Team logo add-on
        if (
          this.addonTeamLogoCheckbox &&
          this.addonTeamLogoCheckbox.checked &&
          this.addonTeamLogoVariantId &&
          this.addonTeamLogoFileInput &&
          this.addonTeamLogoFileInput.files[0]
        ) {
          const fdLogo = new FormData();
          fdLogo.append('id', this.addonTeamLogoVariantId);
          fdLogo.append('quantity', 1);
          fdLogo.append(
            'properties[Team logo file]',
            this.addonTeamLogoFileInput.files[0]
          );

          if (this.cart) {
            fdLogo.append(
              'sections',
              this.cart.getSectionsToRender().map((section) => section.id)
            );
            fdLogo.append('sections_url', window.location.pathname);
            this.cart.setActiveElement(document.activeElement);
          }

          const configLogo = fetchConfig('javascript');
          configLogo.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete configLogo.headers['Content-Type'];
          configLogo.body = fdLogo;

          console.log(
            '[product-form] adding team logo add-on, variant id:',
            this.addonTeamLogoVariantId,
            'file:',
            this.addonTeamLogoFileInput.files[0]?.name
          );

          requests.push(
            fetch(`${routes.cart_add_url}`, configLogo)
              .then((res) => res.json())
              .then((json) => {
                console.log('[product-form] team logo add-on response:', json);
                return json;
              })
          );
        }

        if (!requests.length) {
          console.log(
            '[product-form] no add-ons requested, skipping extra cart_add calls'
          );
          return null;
        }

        const results = await Promise.all(requests);
        console.log('[product-form] all add-on responses:', results);

        // Last response has the final cart state
        return results[results.length - 1];
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}